import React from 'react';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

/* eslint-disable react/prop-types */
const accountsActions = ({ permissions }) => ({
  id: 'action-column',
  Header: 'View',
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { AccessControl.hasPermission(permissions,
        [ActivityPerms.accountPageEdit, ActivityPerms.accountPageView]) && <Link to={ `/account/${ row.original.itemId }` }>
          <button
            type="button"
            className="btn btn-sm btn-sm"
            title="Account Details"
          >
            <span className="icon icon-apps" />
          </button>
        </Link>}
    </div>
  )
});
/* eslint-enable react/prop-types */

export default accountsActions;
